import i18n from "lib/i18n";

// Stable named slugs, not array indices — this content is edited by
// non-engineers and indices would shift (silently re-scrambling which quote
// a learner sees) whenever a quote is added or removed. Per-slug keys also
// mean a missing translation falls back to en-GB for that one quote, not the
// whole array. Mirrors frontend/mobile/src/utility/quotes.ts; the copy lives
// once in the shared @wone/locales `auth` namespace.
export const QUOTE_SLUGS = [
  "gauguinEyes",
  "trueBelongings",
  "midstOfChaos",
  "calmSuperpower",
  "excellenceHabit",
  "reactToIt",
  "natureHurry",
  "lifeIsLong",
  "beautySeeIt",
  "kindnessFlood",
  "lovingSorrow",
  "movementStillness",
  "musicUniverse",
  "happinessPath",
  "opportunityKindness",
  "thinkLightly",
  "acceptYourself",
  "presentJoy",
  "peaceWithinOurselves",
  "compassionIncomplete",
  "walkingOnEarth",
  "walkingEachOtherHome",
  "futureConscious",
  "weAreConnected",
  "journeyThousandMiles",
  "artInevitable",
] as const;

type QuoteSlug = (typeof QUOTE_SLUGS)[number];

const toQuote = (slug: QuoteSlug) => ({
  title: i18n.t(`auth:quotes.${slug}.text`),
  author: i18n.t(`auth:quotes.${slug}.author`),
});

export const getRandomQuote = () => {
  const randomIndex = Math.floor(Math.random() * QUOTE_SLUGS.length);
  return toQuote(QUOTE_SLUGS[randomIndex]);
};

// The quote shown on Home, chosen once per JS session. Home re-renders on
// languageChanged (useTranslation), so memoising the *slug* keeps the same
// quote across re-renders while its text still follows a language change
// instead of re-rolling to a different quote.
let sessionSlug: QuoteSlug | null = null;

export const getSessionQuote = () => {
  if (!sessionSlug) {
    sessionSlug = QUOTE_SLUGS[Math.floor(Math.random() * QUOTE_SLUGS.length)];
  }
  return toQuote(sessionSlug);
};

// Test-only: clears the session memo so each test case picks independently.
export const __resetSessionQuoteForTest = () => {
  sessionSlug = null;
};
